unit CitySetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.DBCtrls,
  Vcl.Controls, WEBLib.ExtCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client;

type
  TfrmCitySetup = class(TForm)
    WebPanel1: TPanel;
    WebLabel1: TLabel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebButton1: TButton;
    WebButton2: TButton;
    WebDBEdit1: TDBEdit;
    wcCity: TXDataWebClient;
    wdsCity: TXDataWebDataSet;
    wdsCityno: TIntegerField;
    wdsCityName: TStringField;
    dsCity: TDataSource;
    procedure WebFormShow(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  frmCitySetup: TfrmCitySetup;

implementation

{$R *.dfm}
uses
  stfmssystem.connection, share.common;

procedure TfrmCitySetup.WebButton2Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmCitySetup.WebFormShow(Sender: TObject);
begin
  wdsCity.Open;
  wdsCity.Insert;
end;

procedure TfrmCitySetup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebDBEdit1 := TDBEdit.Create(Self);
  wcCity := TXDataWebClient.Create(Self);
  wdsCity := TXDataWebDataSet.Create(Self);
  wdsCityno := TIntegerField.Create(Self);
  wdsCityName := TStringField.Create(Self);
  dsCity := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebDBEdit1.BeforeLoadDFMValues;
  wcCity.BeforeLoadDFMValues;
  wdsCity.BeforeLoadDFMValues;
  wdsCityno.BeforeLoadDFMValues;
  wdsCityName.BeforeLoadDFMValues;
  dsCity.BeforeLoadDFMValues;
  try
    Name := 'frmCitySetup';
    Width := 420;
    Height := 220;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 420;
    WebPanel1.Height := 220;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 15;
    WebLabel1.Top := 83;
    WebLabel1.Width := 59;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'City Name:';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 420;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'City Setup';
    WebPanel2.ChildOrder := 1;
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 160;
    WebPanel3.Width := 420;
    WebPanel3.Height := 60;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 1;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 15;
    WebButton1.Top := 16;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Save';
    WebButton1.Color := clGreenyellow;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 136;
    WebButton2.Top := 16;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Cancel';
    WebButton2.Color := clRed;
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebDBEdit1.SetParentComponent(WebPanel1);
    WebDBEdit1.Name := 'WebDBEdit1';
    WebDBEdit1.Left := 15;
    WebDBEdit1.Top := 104;
    WebDBEdit1.Width := 298;
    WebDBEdit1.Height := 22;
    WebDBEdit1.ChildOrder := 2;
    WebDBEdit1.HeightPercent := 100.000000000000000000;
    WebDBEdit1.WidthPercent := 100.000000000000000000;
    WebDBEdit1.DataField := 'Name';
    WebDBEdit1.DataSource := dsCity;
    wcCity.SetParentComponent(Self);
    wcCity.Name := 'wcCity';
    wcCity.Connection := dmData.dbConnect;
    wcCity.Left := 8;
    wcCity.Top := 17;
    wdsCity.SetParentComponent(Self);
    wdsCity.Name := 'wdsCity';
    wdsCity.Connection := dmData.dbConnect;
    wdsCity.Left := 72;
    wdsCity.Top := 17;
    wdsCityno.SetParentComponent(wdsCity);
    wdsCityno.Name := 'wdsCityno';
    wdsCityno.FieldName := 'no';
    wdsCityName.SetParentComponent(wdsCity);
    wdsCityName.Name := 'wdsCityName';
    wdsCityName.FieldName := 'Name';
    dsCity.SetParentComponent(Self);
    dsCity.Name := 'dsCity';
    dsCity.DataSet := wdsCity;
    dsCity.Left := 136;
    dsCity.Top := 17;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebDBEdit1.AfterLoadDFMValues;
    wcCity.AfterLoadDFMValues;
    wdsCity.AfterLoadDFMValues;
    wdsCityno.AfterLoadDFMValues;
    wdsCityName.AfterLoadDFMValues;
    dsCity.AfterLoadDFMValues;
  end;
end;

end.